import BriefingTable from "components/Briefing/subcomponents/table";
import { useEffect, useState } from "react";

import Actions from "components/Briefing/subcomponents/actions"; // Fixed typo (Actoins -> Actions)
import { TextField } from "components/Briefing/subcomponents/safety-subcomponents/fields";
import { useSelector } from "react-redux";
import { crossBorderTrackAndTraceAPI } from "components/Apis/Briefing";
import { getFieldShiftFlag } from "components/Briefing/helpers";
import { SelectField } from "components/Briefing/subcomponents/safety-subcomponents/fields";
import HistoryViewer from "components/Briefing/subcomponents/safety-subcomponents/historyViewer";

const CrossBorderTrackAndTrace = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const briefing = useSelector((state) => state.briefing.line);
    const shift = useSelector((state) => state.shift);

    const archived = (briefing === "Old Briefings");

    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    function backendSync(id, changes) {
        return crossBorderTrackAndTraceAPI.update(id, { ...changes, shift_flag: getFieldShiftFlag(shift) })
            .then(() => {
                setRefresh(!refresh);
            })
    }

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            if (archived) {
                const requestPayload = {
                    "startDate": startDate,
                    "endDate": endDate,
                    "searchTerm": searchTerm
                }
                const response = await crossBorderTrackAndTraceAPI.getArchive(requestPayload); // Changed to truck API
                setData(response.data);
            }
            else {
                const response = await crossBorderTrackAndTraceAPI.filter({
                    archived: false,
                    search_term: searchTerm,
                });
                setData(response.data);
            }
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing]);

    const headers = [
        "ID",
        "Pro #",
        "Customer Set",
        "Notes",
        'Act.'
    ];

    const renderRow = (row) => (
        <>
            <tr key={`track-and-trace-row-${row.id}`} className="safety-row">
                <td className="row-id-cell">
                    <div className="row-id-div">
                        {row.id}
                    </div>
                </td>
                <td style={{ width: "15%" }}>
                    <TextField row={row} label={"pro"} onBackendSync={backendSync} />
                </td>
                <td style={{ width: "15%" }}>
                    <SelectField row={row} label={"customer_set"} options={["RXO", "US", "MX", "TL"]} onBackendSync={backendSync} />
                </td>
                <td>
                    <TextField row={row} label={"notes"} maxLength={500} onBackendSync={backendSync} />
                </td>
                <td className="actions-cell">
                    <Actions
                        onDelete={async () => {
                            crossBorderTrackAndTraceAPI.delete(row.id).then(() => { // Changed to truck API
                                setRefresh(!refresh);
                            }).catch((error) => {
                                console.error("Error deleting row:", error);
                            });
                        }}
                        onArchive={async () => {
                            crossBorderTrackAndTraceAPI.archive(row.id).then(() => { // Changed to truck API
                                setRefresh(!refresh);
                            }).catch((error) => {
                                console.error("Error archiving row:", error);
                            });
                        }}
                    />
                </td>
            </tr>
            <tr className="safety-updated-at-row">
                <td colSpan={headers.length - 1} className="pt-0 pb-0">
                    <span className="input-updated-at-label">
                        Updated by: {row.updated_by ? row.updated_by : "Unknown"} {row.updated_at ? row.updated_at : "Never"}
                    </span>
                </td>
            </tr>
        </>
    );

    return (
        <>
            <div className="table-header">
                <h2>Track & Trace</h2>
                <HistoryViewer historyAPICall={crossBorderTrackAndTraceAPI.getHistory} />
            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={() => crossBorderTrackAndTraceAPI.create().then(() => setRefresh(!refresh))}
            />
        </>
    );
};

export default CrossBorderTrackAndTrace;